import { LegacyRef, useState } from 'react';
import { useIntersection } from 'react-use';

export const useHasEnteredViewport = (
    ref: LegacyRef<HTMLDivElement>,
    options?: { visibleInitial: boolean },
) => {
    const [hasEnteredViewport, setHasEnteredViewport] = useState(
        options?.visibleInitial || false,
    );
    const intersection = useIntersection(ref, {
        root: null,
        rootMargin: '0px 0px 200px 0px',
        threshold: 0.01,
    });

    if (
        intersection &&
        intersection.intersectionRatio > 0 &&
        !hasEnteredViewport
    ) {
        setHasEnteredViewport(true);
    }

    return hasEnteredViewport;
};
